
export const APP_UI = {
  background: "#121417",
  surface: "rgba(20,22,25,0.995)",
  surfaceSolid: "#141619",
  surfaceRaised: "rgba(31,34,38,0.985)",
  card: "rgba(24,27,31,0.975)",
  cardHover: "rgba(31,42,47,0.995)",
  border: "rgba(255,255,255,0.13)",
  borderStrong: "rgba(255,255,255,0.36)",
  accent: "#83cee0",
  accentSoft: "rgba(131,206,224,0.10)",
  accentSurface: "rgba(23,31,34,0.98)",
  successSurface: "rgba(23,33,27,0.98)",
  warningSurface: "rgba(35,30,23,0.98)",
  errorSurface: "rgba(36,23,25,0.98)",
  violetSurface: "rgba(31,27,38,0.98)",
  mutedSurface: "rgba(27,29,32,0.98)",
  accentBorder: "rgba(131,206,224,0.45)",
  success: "#69d27d",
  warning: "#f4a340",
  error: "#ff5b62",
  text: "#f5f5f7",
  textMuted: "#9b9ca2",
  backdrop: "rgba(10,12,14,0.72)",
  sheetRadius: "26px 26px 0 0",
  topSheetRadius: "0 0 26px 26px",
  dialogRadius: 3,
  fieldRadius: 3,
  cardRadius: 2.7,
  touch: 44,
  sheetHandleHeight: 64,
  contentPx: 2,
} as const;

export const APP_FIELD_SX = {
  "& .MuiOutlinedInput-root": {
    minHeight: 56,
    borderRadius: APP_UI.fieldRadius,
    bgcolor: APP_UI.card,
    color: APP_UI.text,
    "& fieldset": { borderColor: APP_UI.borderStrong },
    "&:hover fieldset": { borderColor: "rgba(255,255,255,0.55)" },
    "&.Mui-focused fieldset": { borderColor: APP_UI.accent, borderWidth: 2 },
    "&.Mui-error fieldset": { borderColor: APP_UI.error },
    "&.Mui-disabled": { bgcolor: "rgba(24,27,31,0.96)", color: "rgba(245,245,247,0.46)" },
    "&.Mui-disabled fieldset": { borderColor: "rgba(255,255,255,0.10)" },
  },
  "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.72)" },
  "& .MuiInputLabel-root.Mui-focused": { color: APP_UI.accent },
  "& .MuiInputLabel-root.Mui-error": { color: APP_UI.error },
  "& .MuiInputLabel-root.Mui-disabled": { color: "rgba(245,245,247,0.40)" },
  "& .MuiInputBase-input": { py: 1.7, fontSize: "1rem", color: APP_UI.text },
  "& .MuiInputBase-input.Mui-disabled": { WebkitTextFillColor: "rgba(245,245,247,0.46)" },
  "& .MuiFormHelperText-root": { mx: 0.5, color: APP_UI.textMuted },
} as const;

export const APP_CARD_SX = {
  borderRadius: APP_UI.cardRadius,
  bgcolor: APP_UI.card,
  border: `1px solid ${APP_UI.border}`,
  backgroundImage: "none",
} as const;
